import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject() {
  const data = _taggedTemplateLiteral(["\n    font-style: italic;\n    color: #999;\n"]);

  _templateObject = function () {
    return data;
  };

  return data;
}

import React from 'react';
import styled from 'styled-components';
export const Comment = props => React.createElement(Italic, null, "// ", props.children);
const Italic = styled.span(_templateObject());